import { Link } from "react-router-dom";

export default function Sustainability() {
  return (
    <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl">
        <div className="ie-overline text-brand-accent mb-4">
          Our Approach
        </div>

        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1.05]">
          Sustainability
        </h1>

        <p className="text-text-secondary text-base md:text-lg leading-relaxed mt-6">
          For us, sustainability begins with making fewer things with greater
          intention. We aim to create clothing that can stay in your wardrobe,
          rather than clothing designed only for a moment.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-20">
        <section className="border-t border-border pt-6">
          <div className="ie-overline text-brand-accent mb-4">
            01
          </div>
          <h2 className="font-serif text-2xl mb-4">
            Considered Design
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            We favour timeless silhouettes and thoughtful details over designs
            that depend on short-lived trends.
          </p>
        </section>

        <section className="border-t border-border pt-6">
          <div className="ie-overline text-brand-accent mb-4">
            02
          </div>
          <h2 className="font-serif text-2xl mb-4">
            Longevity
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            A well-made garment should have a life beyond a single season.
            Care and responsible use are part of that journey.
          </p>
        </section>

        <section className="border-t border-border pt-6">
          <div className="ie-overline text-brand-accent mb-4">
            03
          </div>
          <h2 className="font-serif text-2xl mb-4">
            Growing Responsibly
          </h2>
          <p className="text-text-secondary text-sm leading-7">
            As the house grows, we intend to make more informed decisions
            around materials, packaging, production and waste.
          </p>
        </section>
      </div>

      <div className="mt-20 border-t border-border pt-10">
        <p className="text-text-secondary text-sm leading-7 max-w-3xl">
          We believe sustainability is an ongoing responsibility rather than
          a claim of perfection. We will continue refining our practices as
          the house evolves.
        </p>

        <Link to="/shop" className="ie-btn-primary inline-flex mt-8">
          Shop consciously
        </Link>
      </div>
    </div>
  );
}